
import { IProjectSettings } from "../config/IProjectSettings";
import { Collection } from "../utils/Collection";

export interface IProjectConfig
{
	id: string;
	name: string;
	quote?: string; // "0" or "1"
	date?: string;
	settings?: IProjectSettings
	config?: string;
}

export class Project
{
	public static initialElement = new Project({
		name: "Unsaved project",
		id: null
	});

	private _config: IProjectConfig;
	public id : string;
	public name : string;
	public settings : IProjectSettings;
	public date: string;

	constructor(config: IProjectConfig)
	{
		this._config = config;

		this.id = config.id;
		this.name = config.name;
		this.date = config.date;

		if (config.settings)
		{
			this.settings = config.settings;
		}
		else
		{
			if (config.config)
			{
				try {
					this.settings = JSON.parse(config.config);
				} catch(e) {
					console.log(e);
				}
			}
		}

		this.settings = this.settings || null;
	}

	public static createList(configs:IProjectConfig[]):Collection<Project>
	{
		var projects = [Project.initialElement];

		for (var i = 0, ln = configs.length; i < ln; ++i)
		{
			var project = new Project(configs[i]);
			if (project.settings)
			{
				// only add if settings is valid (no parse error, etc)
				projects.push(project);
			}
		}

		return new Collection(projects, "name");
	}

	public get isQuoted()
	{
		return this._config.quote === "1";
	}
}
